controllers.controller('UploadDocumentsOtherController', [
    '$scope', '$q', '$state', '$stateParams', 'LocaleService', 'constants', 'DocumentService', 'DocumentModel', '$ionicPopup',
    function ($scope, $q, $state, $stateParams, LocaleService, Const, DocumentService, DocumentModel, $ionicPopup) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        var documentInfo = {
            id: null,
            type: 'other',
            status: 'new',
            url: '',
            category: '',
            baseCategory: ''
        };

        var modalDefaults = {
            isError: false,
            textTitle: '',
            textContent: '',
            state: false,
            actionText: LocaleService.translation.try_again,
            back: ''
        };

        $scope.modal = angular.copy(modalDefaults);
        
        $scope.files = DocumentService.documentsOther;
        $scope.documentModel = new DocumentModel(documentInfo);

        $scope.uploadFile = function (event) {
            var file = event.target.files[0];
            var document = $scope.documentModel;
            var message = '';
            document.uploadStatus = 0;

            if (!file) return; //exit if no file selected

            if (!checkFileType(file.type)) {
                document.uploadStatus = -1;
                message = LocaleService.translation.file_incorrect_type;
                console.log('invalid file type');
            }
            else if (!checkFileSize(file.size)) {
                document.uploadStatus = -2;
                message = LocaleService.translation.file_is_big_or_small;
                console.log('file too big or small');
            }

            if (document.uploadStatus < 0) {
                $scope.modal.textTitle = LocaleService.translation.messages.Err600;
                $scope.modal.textContent = message;
                $scope.modal.isError = true;
                $scope.modal.state = true;
                return;
            } //exit if file is not validated

            return document.startUpload(file)
                .then(function (newFileName) {
                    return document.uploadFile(file, newFileName)
                })
                .then(function () {
                    document.status = 'new';
                    document.uploadStatus = 0;
                    return DocumentService.initDocuments()
                        .then(function () {
                            $scope.files = DocumentService.documentsOther
                        })
                })
                .catch(function (error) {
                    document.status = 'new';
                    document.uploadStatus = 0;
                    console.warn(error);
                    $scope.modal.textTitle = error && error.code && LocaleService.translation.messages[error.code] || LocaleService.translation.messages.Err600;
                    $scope.modal.textContent = error && error.code && error.code.toString().match(/^Err6\d\d$/) ? LocaleService.translation.messages.general_error_text : '';
                    $scope.modal.isError = true;
                    $scope.modal.state = true;
                })
        };

        $scope.deleteDocument = function (document) {
            var confirmPopup = $ionicPopup.confirm({
                title: LocaleService.translation.document_remove,
                template: LocaleService.translation.document_confirm_remove
            });

            confirmPopup.then(function(res) {
                if(res) {
                    return DocumentService
                        .deleteDocument(document)
                        .catch(function (error) { console.error(error) })
                }
            });
        };
        
        function checkFileType(type) {
            return Const.fileTypes.filter(function (_type) { return _type === type }).length > 0
        }

        function checkFileSize(size) {
            return size >= Const.minFileSize && size <= Const.maxFileSize;
        }
    }]);